/**
 * MAIA ends every answer built from the chart with a "Sources:" line and a
 * markdown list of chart documents (patient-chat-agent system prompt,
 * app/services/answer_sources.py parses it the same way). The widget's
 * "Show sources" toggle only shows or hides that section.
 */

// "Sources:" alone on its line; the model sometimes wraps it in bold or a heading.
const HEADING = /^[ \t]*(?:#{1,6}[ \t]*)?(?:\*\*|__)?Sources:?(?:\*\*|__)?:?[ \t]*$/gim;

export type SplitAnswer = {
  /** The answer above the Sources section (the whole answer when there is none). */
  body: string;
  /** The markdown under the heading; null when the answer has no Sources section. */
  sources: string | null;
};

/** Splits at the last "Sources:" line; an answer without one is all body. */
export const splitSources = (content: string): SplitAnswer => {
  let last: RegExpExecArray | null = null;
  HEADING.lastIndex = 0;
  for (
    let match = HEADING.exec(content);
    match;
    match = HEADING.exec(content)
  ) {
    last = match;
  }
  if (!last) {
    return { body: content, sources: null };
  }
  const sources = content.slice(last.index + last[0].length).trim();
  return {
    body: content.slice(0, last.index).replace(/\s+$/, ''),
    sources: sources || null,
  };
};
